import Api from '@/api/Api'
import Papa from 'papaparse'

//const KIT_SPREADSHEET = "2PACX-1vQh_4dEusoj1xRcT1JV9g9wZ2sWTnHERQj1YdwBsIn9k-IZsy4bch4uToma0Orx9cKkCssJ3AVnhplv"

export default {
  async getKitData (gapi) {
    //return Api().get( KIT_SPREADSHEET + '/pub?output=csv').then((results)=>{
    //return Api().get( 'https://drive.google.com/open?id=1j5jjWSLdXfyhWLvDd2gh-P2aKzahZL0b').then((results)=>{
    /*return Api().get('kit.csv').then((results)=>{
      var csvData = results.data
      var jsonData = Papa.parse(csvData, {
        header : true
      })
      return jsonData
    })
    */
    let res = []
    let response = await gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: '1_nS01Jnl2CT7MEJQR4g6p0-rC4NEsnjAy1HYuR-UhNw',
      range: 'subtopics'
    })
    if(response.result.error){
      console.log('error')
    }
    var range = response.result;
    if (range.values.length > 0) {
      for (let i = 1; i < range.values.length; i++) {
        var row = range.values[i];
        let rowObj = {}
        range.values[0].forEach((field, index) => {
          rowObj[field] = row[index] || ''
        })
        res.push(rowObj)
      }
    } else {
      console.log('No data found.');
    }
    return res
  }
}



// WEBPACK FOOTER //
// ./src/api/KitApi.js